import { useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";
import { DefaultFetchService } from "app/services/fetchService";

interface IAddOnAvailability {
    addonType: string;
    isUpgradeAvailable: boolean;
    isPurchased: boolean;
}

interface IAvailableProductTypesResponse {
    addOnTypes: string[];
    addOnAvailabilities: Record<string, IAddOnAvailability>;
}

interface IUseAvailableProductsApi {
    isSuccess: boolean;
    isError: boolean;
    isLoading: boolean;
    addOnTypes: string[];
    addOnAvailabilities: Record<string, IAddOnAvailability>;
}

interface IUseAvailableProductsOptions {
    enabled?: boolean;
}

const url = "/api/notouch/addons/available-types";

export const useAvailableProducts = (options: IUseAvailableProductsOptions = {}): IUseAvailableProductsApi => {
    const { enabled = true } = options;
    const {
        isSuccess,
        isError,
        isLoading,
        data: productTypes,
    } = useQuery<IAvailableProductTypesResponse>({
        queryKey: ["product-types"],
        enabled,
        queryFn: async () => {
            const fetchService = DefaultFetchService.getInstance();
            return await fetchService.get<IAvailableProductTypesResponse>(url, {});
        },
        throwOnError: (error) => {
            Sentry.errorTracker({
                e: error,
                message: "Error fetching available product types",
                level: "error",
                params: {
                    tags: { team: TEAMS.LYNX },
                },
            });
            return false;
        },
    });

    return {
        isSuccess,
        isError,
        isLoading,
        addOnTypes: productTypes?.addOnTypes ?? [],
        addOnAvailabilities: productTypes?.addOnAvailabilities ?? {},
    };
};
